






























import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { createRestartPanelCommand } from "@/data/repository/PanelRequestRepository";
import Panel from "@/data/models/Panel";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class PanelSettingsComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Prop()
  panel!: Panel;

  get panelIpuFirmware() {
    return `${this.panel.firmwareRevision}.${this.panel.buildVersion}`;
  }

  get configName() {
    return this.panel.configurationName;
  }

  async show() {
    this.baseDialogComponent.show({
      title: this.$t("panelSettings.title", [this.panel.serialNo]).toString(),
      positiveButtonText: null,
      persistent: false,
    });
  }

  async onRestartPanel() {
    const confirmed = await this.confirmationDialogComponent.show({
      title: this.$t("panelSettings.restartConfirmTitle", [this.panel.serialNo]).toString(),
      message: this.$t("panelSettings.restartConfirmMessage").toString(),
      acceptMessage: this.$t("panelDetail.actions.restart").toString(),
    });
    if (!confirmed) {
      return;
    }

    await createRestartPanelCommand(this.panel.serialNo);
    SnackbarModule.showSuccess({ key: "panelControl.queuedRequestRestartPanel" });
  }
}
